/* This file is auto-generated, do not touch! Please edit the SVG file instead. */
import React from "react";
import { css } from "glamor";

function Merge({ width, height, style, color = "currentColor", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      {...css(style)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 29H29.3333"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.00002 29H2.66669"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16 21L8 29"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16 21L24 29"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16 2.66669V21.3334"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16 2.66669L8 9.33335"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16 2.66669L24 9.33335"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Merge;
